import { type FC } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

import { StaticImage } from '../../../image'
import ImgFamilyNfc from '../../images/ImgFamilyNfc.png'
import { NfcLandingPageTitle } from '../NfcLandingPageTitle/NfcLandingPageTitle'
import { nfcLandingPageTextAccentNowrap } from '../NfcLandingPageTranslationValues'

export const NfcLandingPageFamilyPrescriptionSection: FC = () => {
  const intl = useIntl()

  return (
    <div
      className="container flex scroll-mt-4 flex-col gap-4 tablet:scroll-mt-0 tablet:flex-row tablet:gap-6 tablet:py-12"
      id="familie"
    >
      <div className="flex w-full flex-col justify-center gap-6 tablet:order-2">
        <NfcLandingPageTitle>
          <FormattedMessage
            id="nfc.familyPrescriptionSection.title"
            values={{
              accentuate: nfcLandingPageTextAccentNowrap,
            }}
          />
        </NfcLandingPageTitle>

        <span className="hidden text-m tablet:block">
          <FormattedMessage
            id="nfc.familyPrescriptionSection.description"
            values={{
              accentuate: nfcLandingPageTextAccentNowrap,
            }}
          />
        </span>
      </div>

      <StaticImage
        alt={intl.formatMessage({
          id: 'nfc.familyPrescriptionSection.image.alt',
        })}
        className="w-full object-contain px-4 tablet:order-1 tablet:w-2/5 tablet:px-0"
        src={ImgFamilyNfc}
      />

      <span className="text-s tablet:hidden">
        <FormattedMessage
          id="nfc.familyPrescriptionSection.description"
          values={{
            accentuate: nfcLandingPageTextAccentNowrap,
          }}
        />
      </span>
    </div>
  )
}
